<app-hatch-defs></app-hatch-defs>

<div class="section-card" #exportRef>
  <div class="section-header">
    <span class="section-title">Desglose de ingresos por día de la semana</span>
    <div class="export-actions">
      <button class="export-btn" (click)="exportar('png')" title="Exportar imagen">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg>
        IMG
      </button>
      <button class="export-btn" (click)="exportar('pdf')" title="Exportar PDF">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>
        PDF
      </button>
    </div>
  </div>
  <div class="day-chips">
    <div class="day-chip" *ngFor="let d of diasSemana">
      <div class="day-name">{{ d.nombre }}</div>
      <div class="day-value" [style.color]="d.color">{{ formatShort(d.pesos) }}</div>
      <div class="day-kg" [style.color]="d.colorKg">{{ d.kg | number:'1.0-0' }} Kg</div>
    </div>
  </div>
  <dx-chart [dataSource]="diasSemana" [customizePoint]="customizePromPoint" class="prom-chart">
    <dxi-series valueField="pesos" argumentField="nombre" type="bar" name="Pesos" axis="pesos">
      <dxo-label [visible]="false"></dxo-label>
    </dxi-series>
    <dxi-series valueField="kg" argumentField="nombre" type="bar" name="Kg" axis="kg" color="#4f9ef8">
      <dxo-label [visible]="false"></dxo-label>
      <dxo-hatching direction="right" [width]="4" [step]="10" [opacity]="1"></dxo-hatching>
    </dxi-series>
    <dxi-value-axis name="pesos" position="left"></dxi-value-axis>
    <dxi-value-axis name="kg" position="right"></dxi-value-axis>
    <dxo-argument-axis [discreteAxisDivisionMode]="'crossLabels'">
      <dxo-label overlappingBehavior="none"></dxo-label>
    </dxo-argument-axis>
    <dxo-legend [visible]="false"></dxo-legend>
    <dxo-tooltip [enabled]="true" [customizeTooltip]="customizeTooltip"></dxo-tooltip>
    <dxo-export [enabled]="false"></dxo-export>
  </dx-chart>
</div>
